import { FC, Fragment } from 'react'
import { ListItem, ListItemText, Typography } from '@mui/material'
import { tss } from '@dhl/theme'
import { SideMenuListItem } from './SideMenuListItem.js'
import { MenuItemWithSubItems } from './types.js'

type Props = {
  disableTab: boolean
  isExpanded: boolean
  menuItems: MenuItemWithSubItems[]
  navigationPath?: string
}

const useStyles = tss.makeStyles()((theme) => ({
  header: {
    color: theme.palette.grey[600],
  },
}))

const isActive = (navigationPath: string | undefined, link: string | undefined): boolean => {
  if (!navigationPath || !link) {
    return false
  }
  return navigationPath.startsWith(link)
}

export const SideMenuInline: FC<Props> = ({ disableTab, isExpanded, menuItems, navigationPath }) => {
  const { classes } = useStyles()

  return (
    <>
      {menuItems.map((item) => {
        if (item.subMenuItems) {
          return (
            <Fragment key={item.key}>
              {isExpanded && (
                <ListItem id={item.id}>
                  <ListItemText
                    primary={
                      <Typography variant="body2" className={classes.header}>
                        {item.label}
                      </Typography>
                    }
                    disableTypography
                  />
                </ListItem>
              )}
              <SideMenuInline
                disableTab={disableTab}
                isExpanded={isExpanded}
                menuItems={item.subMenuItems}
                navigationPath={navigationPath}
              />
            </Fragment>
          )
        }

        return (
          <SideMenuListItem
            isExpanded={isExpanded}
            key={item.key}
            disableTab={disableTab}
            menuItem={{
              ...item,
              active: item.active === undefined ? isActive(navigationPath, item.link) : item.active,
            }}
          />
        )
      })}
    </>
  )
}
